import {
  ArrowCircleRight,
  CheckCircle,
  CircleNotch,
  IconContext,
  Prohibit,
} from '@phosphor-icons/react';
import { Wrapper } from './wrapper';

export type OperationsStateIconStates = 'completed' | 'inProgress' | 'notStarted' | 'problem';

interface OperationsStateIconProps {
  state: OperationsStateIconStates;
}

const resolveIcon = (state: OperationsStateIconStates) => {
  switch (state) {
    case 'completed':
      return <CheckCircle />;
    case 'inProgress':
      return <CircleNotch />;
    case 'problem':
      return <Prohibit />;
    default:
      return <ArrowCircleRight />;
  }
};

const OperationsStateIcon = ({ state }: OperationsStateIconProps) => {
  return (
    <Wrapper $state={state}>
      <IconContext.Provider
        value={{
          size: '1em',
          weight: 'fill',
        }}
      >
        {resolveIcon(state)}
      </IconContext.Provider>
    </Wrapper>
  );
};

export default OperationsStateIcon;
